import tooltip from "./tooltip.js";

export default {
  tooltip,
}
